import { useBreadcrumb } from "components/breadcrumb/BreadcrumbContext";
import { brandConfig } from "config/brandConfig";
import { useEffect } from "react";
import SEOMeta from "components/SEOMeta";
import { Link } from "react-router-dom";

export default function About() {
  const { setItems } = useBreadcrumb();
  useEffect(() => {
    setItems([{ label: "Accueil", href: "/" }, { label: "À propos" }]);
  }, [setItems]);
  return (
    <>
      <SEOMeta
        title={`À propos -${brandConfig.brandName}`}
        description={`Découvrez l'histoire et les valeurs de ${brandConfig.brandName}, fabricant français d'armoires à fusils sécurisées.`}
        canonicalPath="/about"
      />
      <section className="about">
        <h1>Notre histoire</h1>
        <p>
          Kaiser Safe est né d’une conviction simple : la sécurité de vos armes
          mérite une solution fiable, robuste et pensée pour durer.
        </p>

        <p>
          Son fondateur, <strong>Clément Forestier</strong>, a créé la marque
          avec l’ambition de proposer des armoires à fusils modernes, alliant
          normes de sécurité strictes et esthétisme sobre. Passionné
          d’innovation et entrepreneur engagé, il a voulu mettre son expérience
          au service d’un produit spécialisé, accessible et durable.
        </p>

        <p>
          Aujourd’hui, Kaiser Safe se développe en Europe et principalement en
          France, avec un objectif : devenir la référence des armoires à fusils,
          en gardant toujours au cœur de son engagement la <em>confiance</em> et
          la <em>proximité avec ses clients</em>.
        </p>
        <p>
          Pour toute questin supplémentaire, n'héstiez pas à{" "}
          <Link to="/contact">nous contacter</Link>
        </p>
      </section>
    </>
  );
}
